import { Component, OnInit } from '@angular/core';
import { HelperService } from "../../services/helper/helper.service";
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../toast/toast.component';
import { Router } from "@angular/router";

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { BinaService } from '../../services/bina/bina.service';

import { ConfirmDialogComponent } from '../popups/confirm-dialog/confirm-dialog.component';

import { AddBinasComponent } from '../popups/add-binas/add-binas.component';

import { ConfirmBinasComponent } from '../popups/confirm-binas/confirm-binas.component';

@Component({
    selector: 'app-binas',
    templateUrl: './binas.component.html',
    styleUrls: ['./binas.component.scss']
})
export class BinasComponent implements OnInit {

    public searchFilter;
    public loading;
    public user = {};
    public selectedOrder = 'last';

    public filteredBinas = [];

    public atualPage = 'binas';

    public binas = [];

    constructor(
        private helperService: HelperService,
        private snackBar: MatSnackBar,
        private router: Router,
        public dialog: MatDialog,
        public binaService: BinaService
    ) { }

    ngOnInit() {
        this.init();
    }

    init() {
        this.binas = [];
        this.loading = true;
        this.helperService.init().then((res) => {
            this.loading = false;
            if (res) {
                this.user = res;
                this.list();
            } else {
                this.snackBar.openFromComponent(ToastComponent, {
                    data: "Assinatura Inválida"
                });
                this.router.navigate(['/notfound']);
            }
        })
    }

    list(callback = null) {
        this.loading = true;
        this.binaService.list().subscribe((res) => {
            this.binas = res.binas;
            this._filter('');
            
            this.loading = false;

            if (callback) callback();
        })
    }


    openDialogAdd(): void {

        const dialogRef = this.dialog.open(AddBinasComponent, {
            width: '350px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.openDialogConfirm(result)
            } else {
                this.init();
            }
        });

    }

    openDialogConfirm(id): void {

        const dialogRef = this.dialog.open(ConfirmBinasComponent, {
            width: '350px',
            data: {
                id: id
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.init();
        });

    }

    openDialogDelete(id): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '600px',
            data: {
                msg: "Tem certeza que deseja deletar essa bina?",
                id: id
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (result.confirm) {
                    this.deleteBina(result.id)
                }
            }
        });
    }

    deleteBina(id) {
        this.loading = true;
        this.binas = [];

        this.binaService.delete(id).subscribe((res) => {
            this.loading = false;
            this.snackBar.openFromComponent(ToastComponent, {
                data: res.msg
            });
            this.init();
        })
    }

    _filter(value) {
        this.filteredBinas = this.binas.filter((peer) => {
            var fields = Object.entries(peer);
            if (this.checkFilter(value, fields)) {
                return peer;
            }

        })
        this.orderBy();
    }

    checkFilter(value, fields) {
        var found = false;
        fields.forEach((field) => {
            if (field[1] != null) {
                if (field[1].toString().toLowerCase().includes(value.toLowerCase())) {
                    found = true;
                }

                if (field[1] == 0) {
                    if ("Pendente".toLocaleLowerCase().includes(value.toLowerCase())) {
                        found = true;
                    }
                }

                if ((field[1] == 1) && (field[0] != 'active')) {
                    if ("Confirmado".toLocaleLowerCase().includes(value.toLowerCase())) {
                        found = true;
                    }
                }
            }
        })
        return found;
    }

    orderBy() {

        var arrayTemp = JSON.parse(JSON.stringify(this.filteredBinas));

        for (var i = 0; i < arrayTemp.length - 1; i++) {
            for (var j = i + 1; j < arrayTemp.length; j++) {
                if (this.selectedOrder == 'last') {
                    if (new Date(arrayTemp[j].created_at) > new Date(arrayTemp[i].id)) {
                        var auxValue = arrayTemp[i];
                        arrayTemp[i] = arrayTemp[j];
                        arrayTemp[j] = auxValue;
                    }
                } else {
                    if (new Date(arrayTemp[j].id) < new Date(arrayTemp[i].id)) {
                        var auxValue = arrayTemp[i];
                        arrayTemp[i] = arrayTemp[j];
                        arrayTemp[j] = auxValue;
                    }
                }
            }
        }
        this.filteredBinas = JSON.parse(JSON.stringify(arrayTemp));
    }

}
